export default "__VITE_ASSET__CORPpXHz__"